import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const apiClient = axios.create({
  baseURL: `${API_BASE}/api`,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('ainaa_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 && !error.config._retry) {
      error.config._retry = true;
      try {
        const refreshToken = localStorage.getItem('ainaa_refresh_token');
        if (refreshToken) {
          const { data } = await axios.post(`${API_BASE}/api/auth/refresh`, { refresh_token: refreshToken });
          if (data.access_token) {
            localStorage.setItem('ainaa_token', data.access_token);
            error.config.headers.Authorization = `Bearer ${data.access_token}`;
            return apiClient(error.config);
          }
        }
      } catch (_) {
        localStorage.removeItem('ainaa_token');
        localStorage.removeItem('ainaa_refresh_token');
        localStorage.removeItem('ainaa_admin_logged_in');
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
